<template>
  <div>
    <h2>设备检测统计</h2>

    <el-row :gutter="20" class="search-bar">
      <el-col :span="5">
        <el-input v-model="search.deviceKeyword" placeholder="设备编号" clearable @keyup.enter="doSearch" />
      </el-col>
      <el-col :span="5">
        <el-input v-model="search.accountKeyword" placeholder="账户名称" clearable @keyup.enter="doSearch" />
      </el-col>
      <el-col :span="4">
        <el-select v-model="search.reagentTypeId" placeholder="试剂类型" clearable style="width:100%;">
          <el-option v-for="item in reagentTypeList" :key="item.id" :label="item.reagentName" :value="item.id" />
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="search.isShared" placeholder="是否共享" clearable style="width:100%;">
          <el-option label="共享设备" value="1" />
          <el-option label="非共享" value="0" />
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="search.riskStatus" placeholder="风险状态" clearable style="width:100%;">
          <el-option label="正常" value="NORMAL" />
          <el-option label="注意" value="MEDIUM" />
          <el-option label="异常" value="HIGH" />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="doSearch">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" border style="width:100%;" v-loading="loading"
      :row-class-name="getRowClassName">
      <el-table-column prop="deviceNo" label="设备编号" min-width="120" />
      <el-table-column prop="bindAccounts" label="绑定账户" min-width="120" />
      <el-table-column label="是否共享" width="100" align="center">
        <template v-slot="scope">
          <el-tag v-if="scope.row.isShared === 1" type="warning" size="small">共享设备</el-tag>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="reagentName" label="试剂名称" min-width="120" />
      <el-table-column prop="monthTestTimes" label="本月检测次数" width="110" align="center" />
      <el-table-column prop="totalTestTimes" label="累计检测次数" width="110" align="center" />
      <el-table-column label="风险状态" width="90" align="center">
        <template v-slot="scope">
          <el-tag :type="getRiskTagType(scope.row.riskStatus)" size="small">{{ scope.row.riskText }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template v-slot="scope">
          <el-button type="text" size="small" @click="viewDetail(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
     <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
       :current-page="page.current" :page-size="page.pageSize" :total="page.total"
       :page-sizes="[20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" />
    </div>
  </div>
</template>

<script>
import { fetchDeviceMonitorPage, fetchReagentTypeList } from "@/api/reagentMonitor";

export default {
  data() {
    return {
      search: { deviceKeyword: "", accountKeyword: "", reagentTypeId: null, isShared: "", riskStatus: "" },
      tableData: [],
     page: { current: 1, pageSize: 20, total: 0 },
      loading: false,
      reagentTypeList: [],
    };
  },
  created() {
    this.loadReagentTypes();
    this.doSearch();
  },
  methods: {
    async loadReagentTypes() {
      try {
        const res = await fetchReagentTypeList();
        if (res.code === 200) {
          this.reagentTypeList = res.data || [];
        }
      } catch (e) { console.error(e); }
    },
    async doSearch() {
      this.loading = true;
      try {
        const res = await fetchDeviceMonitorPage({
          deviceKeyword: this.search.deviceKeyword || undefined,
          accountKeyword: this.search.accountKeyword || undefined,
          reagentTypeId: this.search.reagentTypeId || undefined,
          isShared: this.search.isShared || undefined,
          riskStatus: this.search.riskStatus || undefined,
          current: this.page.current,
          pageSize: this.page.pageSize,
        });
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.page.total = res.data.total || 0;
        }
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    resetSearch() {
      this.search = { deviceKeyword: "", accountKeyword: "", reagentTypeId: null, isShared: "", riskStatus: "" };
      this.page.current = 1;
      this.doSearch();
    },
    viewDetail(row) {
      this.$router.push({ path: `/reagent-monitor/device/detail/${row.deviceId}` });
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.current = 1;
      this.doSearch();
    },
    handleCurrentChange(page) {
      this.page.current = page;
      this.doSearch();
    },
    getRowClassName({ row }) {
      if (row.isShared === 1) return "shared-device-row";
      return "";
    },
    getRiskTagType(status) {
      if (status === "HIGH") return "danger";
      if (status === "MEDIUM") return "warning";
      return "success";
    },
  },
};
</script>

<style scoped>
.search-bar { margin-bottom: 16px; }
.pagination { margin-top: 16px; display: flex; justify-content: flex-end; }
:deep(.shared-device-row) { background: #fff7e6; }
</style>
